module.exports = __webpack_public_path__ + "static/media/default.8fed3c43.png";